import { projectListCellCss } from "./ScreenerTable.css"

export const VirtualPadding = ({
  padding,
}: {
  padding: number | undefined
}) => {
  if (!padding) return null

  return (
    <td
      className={projectListCellCss}
      style={{
        width: padding,
      }}
    />
  )
}
